import { 
    GET_LIST_QUARTERTARIFF, 
    GET_LIST_QUARTERTARIFF_FAIL, 
    GET_LIST_QUARTERTARIFF_SUCCESS,
    UPSERT_QUARTERTARIFF,
    UPSERT_QUARTERTARIFF_SUCCESS,
    UPSERT_QUARTERTARIFF_FAIL,
    DELETE_QUARTERTARIFF,
    DELETE_QUARTERTARIFF_SUCCESS,
    DELETE_QUARTERTARIFF_FAIL,
    RESET_QUARTERTARIFF_MESSAGES
} from "./actionTypes"

//-----------------------------------------------------get List QuarterTariff
export const getListQuarterTariff = () =>({
    type:GET_LIST_QUARTERTARIFF
})

export const getListQuarterTariffSuccess = events =>({
    type:GET_LIST_QUARTERTARIFF_SUCCESS,
    payload:events
})
export const getListQuarterTariffFail = error =>({
    type:GET_LIST_QUARTERTARIFF_FAIL,
    payload:error
})

//-----------------------------------------------------Upsert QuarterTariff
export const upsertQuarterTariff = (data) => ({
    type: UPSERT_QUARTERTARIFF,
    payload: data
})

export const upsertQuarterTariffSuccess = (response) => ({
    type: UPSERT_QUARTERTARIFF_SUCCESS,
    payload: response
})

export const upsertQuarterTariffFail = (error) => ({
    type: UPSERT_QUARTERTARIFF_FAIL,
    payload: error
})

//-----------------------------------------------------Delete QuarterTariff
export const deleteQuarterTariff = (id) => ({
    type: DELETE_QUARTERTARIFF,
    payload: id
})

export const deleteQuarterTariffSuccess = (id) => ({
    type: DELETE_QUARTERTARIFF_SUCCESS,
    payload: id
})

export const deleteQuarterTariffFail = (error) => ({
    type: DELETE_QUARTERTARIFF_FAIL,
    payload: error
})

//-----------------------------------------------------Reset Messages
export const resetQuarterTariffMessages = () => ({
    type: RESET_QUARTERTARIFF_MESSAGES
})